import {
  ApacCandidateFooter,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { Box, Divider } from 'braid-design-system';
import React, { type ComponentProps } from 'react';
import { useDispatch } from 'react-redux';

import { useAuthenticationStatus } from 'src/context/use-user';
import { headerFooterLinkClicked } from 'src/reducers/location';

import { mapLinkAction } from './utils';

type ApacFooterAuthenticationStatus = ComponentProps<
  typeof ApacCandidateFooter
>['authenticationStatus'];

export const FooterContainer = () => {
  const dispatch = useDispatch();
  const authenticationStatus = useAuthenticationStatus();

  return (
    <ApacCandidateHeaderFooterLinkProvider
      value={{
        sendLinkEvent: ({ linkContext }) => {
          dispatch(
            headerFooterLinkClicked({
              linkPosition: 'footer',
              linkText: (linkContext?.source as string) || 'none',
              linkAction: linkContext?.openingOrClosing
                ? mapLinkAction(linkContext.openingOrClosing as string)
                : undefined,
            }),
          );
        },
      }}
    >
      <Box position="relative" zIndex={1} paddingTop="xxxlarge">
        <Divider />
      </Box>
      <ApacCandidateFooter
        authenticationStatus={
          authenticationStatus as ApacFooterAuthenticationStatus
        }
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};
